import React from "react"
import SearchableMultiSelectFilter from "../../base/SearchableMultiSelectFilter"
import type { Customer } from "@shared/types/customers"
import { mockCustomers } from "@shared/data/mockCustomers"

interface CustomerFiltersProps {
  customersValue?: string[]
  customerOptions?: Customer[]
  onCustomersChange?: (value: string[] | null) => void
  className?: string
}

interface CustomerOption extends Customer {
  value: string
  label: string
}

const CustomerSelectFilter = ({ 
  value = [], 
  onChange, 
  options,
  className 
}: {
  value?: string[]
  onChange?: (value: string[] | null) => void
  options?: Customer[]
  className?: string
}) => {
  // Use provided options or fallback to mock data
  const customerOptions = options || mockCustomers

  // Transform customers to match SearchableMultiSelectOption interface
  const transformedOptions: CustomerOption[] = customerOptions.map(customer => ({
    ...customer,
    value: customer.id,
    label: customer.name,
  }))

  const renderCustomerOption = (option: CustomerOption) => (
    <div className="flex-1 min-w-0 flex items-center gap-1.5 text-xs truncate">
      <span className="font-medium text-sm truncate">{option.name}</span>
      <span className="text-border">·</span>
      <span className="text-muted-foreground truncate">{option.email}</span>
      <span className="text-border">·</span>
      <span className="text-muted-foreground shrink-0">ID: {option.id}</span>
    </div>
  )

  return (
    <SearchableMultiSelectFilter
      value={value}
      onChange={onChange}
      options={transformedOptions}
      searchFields={['name', 'email', 'id']}
      displayTitle="Select Customers"
      searchPlaceholder="Search by name, email, or ID..."
      filterKey="customers"
      filterLabel="Customers"
      className={className}
      renderOption={renderCustomerOption}
      getOptionValue={(option) => option.id}
    />
  )
}

export const CustomerFilters = ({
  customersValue,
  customerOptions,
  onCustomersChange,
  className,
}: CustomerFiltersProps) => {
  return (
    <CustomerSelectFilter
      value={customersValue}
      onChange={onCustomersChange}
      options={customerOptions}
      className={className}
    />
  )
}

export default React.memo(CustomerFilters)
